<template>
<form
  :method="methodType"
  accept-charset="UTF-8"
  autocomplete="off"
  :action="this.apiUrl(actionUrl, true)"
  id="partner-form"
  :reset="true"
  v-on:submit.prevent="submit"
>

  <div class="form-group">
    <label for="partner_name">
      Partner Name
    </label>

    <input
      type="text"
      name="partner[name]"
      id="parnter_name"
      class="form-control"
      v-model="name"
    />
  </div>

  <div class="form-group">
    <label for="partner_description">
      Partner Description
    </label>

    <textarea
      type="text"
      name="partner[description]"
      id="parnter_description"
      class="form-control"
      v-model="description"
    ></textarea>
  </div>

  <div class="form-group">
    <h4>Apps</h4>

    <div>
      <label for="partner_description">
        New App Name
      </label>

      <input
        type="text"
        name="partner[partner_apps_attributes][][name]"
        id="parnter_name"
        class="form-control"
      />

    </div>
  </div>

  <div class="form-group row">
    <div class="col">
      <label for="partner_inactive">
        <input type="hidden" name="partner[inactive]" value="false" />
        <input
          type="checkbox"
          name="partner[inactive]"
          id="partner_inactive"
          v-model="inactive"
        />

        Inactive?
      </label>
    </div>
  </div>

  <button
    class="form-control btn btn-primary"
    type="submit"
  >
    {{ actionLbl }} Partner
  </button>

  <div
    id="partner-destructive-options"
    v-if="partnerId"
  >
    <hr />

    <button
      class="form-control btn btn-danger"
      v-on:click.prevent="resetApiToken"
    >
       Reset Partner App API Token
    </button>

    <hr />

    <button
      class="form-control btn btn-danger"
      v-on:click.prevent="destroy"
      v-if="id"
    >
       Delete Partner
    </button>
  </div>

</form>

</template>

<script>
import FlashStore from '@/stores/FlashStore'
import PartnerStore from '@/stores/PartnerStore'

export default {
  data () {
    return PartnerStore.state
  },

  computed: {
    actionLbl () {
      return this.partnerId ? 'Edit' : 'Create'
    },

    actionUrl () {
      return '/partners/' + (this.partnerId ? this.partnerId : '')
    },

    methodType () {
      return this.partnerId ? 'PUT' : 'POST'
    }

  },

  props: [
    'partnerId'
  ],

  created () {
    if (this.partnerId) {
      this.get()
    }
  },

  methods: {
    get () {
      this.apiGet(this.actionUrl, PartnerStore, true).then((resp) => {
        this.apps = resp.relationships.apps
      })
    },

    destroy () {
      if (confirm(
        'Are you sure you want to delete this Partner?'
      )) {
        if (confirm(
          'Are you absolutely sure? You cannot undo Partner deletion.'
        )) {
          this.$http.delete(
            this.apiUrl(this.actionUrl, true)
          ).then((resp) => {
            this.$router.push({
              name: 'partners'
            })

            FlashStore.result('Partner deleted.')
          }, this.processErrors)
        }
      }
    },

    resetApiToken () {
      if (confirm(
        'Are you sure you want to regenerate this Partner API Token? ' +
        'This partner will no longer be able access the service ' +
        'until they update it with the new token.'
      )) {
        this.$http.post(
          this.apiUrl(
            '/partners/' + this.partnerId + '/regenerate_api_token', true
          )
        ).then((resp) => {
          this.processSuccess(resp)

          this.$router.push({
            name: 'partner',
            params: {
              'partnerId': this.partnerId
            }
          })

          FlashStore.result('API token regenerated.')
        }, this.processErrors)
      }
    },

    submit (ev) {
      this.bindSubmit(ev).then((resp) => {
        const partner = this.processSuccess(resp)

        this.$router.push({
          name: 'partner',
          params: {
            'partnerId': partner.id
          }
        })
      }, this.processErrors)
    },

    processErrors (resp) {
      this.$parent.processErrors(resp)
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/PartnerForm.vue